module.exports = __webpack_public_path__ + "static/media/siemens-logo-charcoal.121a2977.svg";